<ng-container *transloco="let t; scope: 'checkout'">
  <ng-container *ngIf="item.sItemText">
    <div>{{ t("checkout.cart-overview.details") }}</div>
    <div class="item-text">{{ item.sItemText }}</div>
  </ng-container>
</ng-container>
